import { render, staticRenderFns } from "./yaoqhdgz_config.vue?vue&type=template&id=3b62d5fc&scoped=true"
import script from "./yaoqhdgz_config.vue?vue&type=script&lang=js"
export * from "./yaoqhdgz_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b62d5fc",
  null
  
)

export default component.exports